export default __webpack_public_path__ + "./assets/background__85a1d765d4368800651e9d2dd868cde0.png";